<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row v-auth-acl="'gh-cal-mat_com-read'">
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizTable></MatrizTable>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CalendarioYComites',
  components: {
    MatrizTable: () => import('../components/MatrizTable')
  },
  data: () => ({
    page: {
      title: 'Calendario Y Comités'
    },
    breadcrumbs: [
      {
        text: 'Calendario Y Comités',
        disabled: true
      },
      {
        text: 'Matriz de Comites',
        disabled: false
      }
    ]
  }),
  methods: {}
};
</script>
